import "assets/scss/components/item.scss";
import React from "react";
import { useApp } from "context";
import { Box, Typography } from "@mui/material";
import { Item } from "components";
import { IService } from "interfaces";

type Props = {
  service: IService;
  children?: React.ReactNode;
  onClick: (value: IService) => void;
};

export const Service = (props: Props) => {
  const { theme } = useApp();

  const handleClick = () => props.onClick && props.onClick(props.service);

  return (
    <Box
      component="div"
      className="qh-item qh-service"
      onClick={handleClick}
      sx={{
        backgroundColor: theme.palette.background.color,
      }}
    >
      <div className="wrapper">
        {props.children}
        <Item.ServiceIcon serviceId={props.service.serviceId} />
        <Typography
          component="span"
          sx={{
            fontSize: theme.font.md,
            color: theme.palette.font.color,
          }}
        >
          {props.service.serviceName}
        </Typography>
      </div>
    </Box>
  );
};
